import { format, isToday, isValid, startOfDay } from 'date-fns'

import { DATE_FULL_FORMAT, DATE_HOURS_FORMAT } from '../../../../constants/date'
import { isValueStringType } from '../../../../utils/common'
import {
  toUkTimezoneDate,
  transposeToUkTimezoneDate,
} from '../../../../utils/date'

export function formatDate({
  date,
  dateFormat = DATE_FULL_FORMAT,
  locale,
  timezone,
  useTodayFormat = true,
}) {
  if (date) {
    const dateStringWithTime = isValueStringType(date) && date.includes('T')
    const ukDate =
      dateStringWithTime || isValid(date)
        ? toUkTimezoneDate(date, timezone)
        : transposeToUkTimezoneDate(startOfDay(date), timezone)

    return format(
      ukDate,
      isToday(ukDate) && useTodayFormat ? DATE_HOURS_FORMAT : dateFormat,
      {
        locale,
      }
    )
  }
}

export function getTooltip(date, locale, timezone) {
  const ukDate = toUkTimezoneDate(date, timezone)

  return isToday(ukDate)
    ? format(ukDate, DATE_FULL_FORMAT, {
        locale,
      })
    : null
}
